module.exports = __webpack_public_path__ + "static/media/image-placeholder-ruler.894b813d.jpg";